import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Inverter from "./Inverter";
import { useTranslation } from 'react-i18next';

const PCS = ({ id, inverters, toggleInverter, switches, toggleSwitch }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedSwitch, setSelectedSwitch] = useState(null);
    const [selectedInverter, setSelectedInverter] = useState(null); // Nuevo estado para el inverter seleccionado
    const { t } = useTranslation();
    const midIndex = Math.ceil(inverters.length / 2);
    const leftInverters = inverters.slice(0, midIndex);
    const rightInverters = inverters.slice(midIndex);

    const handleSwitchClick = (side) => {
        setSelectedSwitch(side);
        setShowModal(true);
    };

    const handleInverterClick = (inv) => {
        setSelectedInverter(inv);
        setShowModal(true);
    };

    const handleModalClose = () => setShowModal(false);

    const handleModalConfirmSwitch = () => {
        if (selectedSwitch) {
            toggleSwitch(selectedSwitch);
            setShowModal(false);
        }
    };

    const handleModalConfirmInverter = () => {
        if (selectedInverter) {
            toggleInverter(selectedInverter.idInverter);
            setShowModal(false);
        }
    };

    const isInverterInFault = selectedInverter && selectedInverter.statusLevel === "3";

    return (
        <div className="pcs" id={id}>
            <div className="line-cable">
                <div className="vertical-line-left"></div>
                <div className="vertical-line-right"></div>

                <div className="switch left" onClick={() => handleSwitchClick("left")}>
                    <div className={`switch ${switches.left.state ? "on" : "off"}`}></div>
                    <div className="switch-text">
                        <div className="switch-name">{switches.left.name}</div>
                        <div className="switch-state">
                            {t('scada.solarFarm.CT.schema.state')} {switches.left.state ? "On" : "Off"}
                        </div>
                    </div>
                </div>
                <div className="line-between-switches" />
                <div className="switch right" onClick={() => handleSwitchClick("right")}>
                    <div className={`switch ${switches.right.state ? "on" : "off"}`}></div>
                    <div className="switch-text">
                        <div className="switch-name">{switches.right.name}</div>
                        <div className="switch-state">
                            {t('scada.solarFarm.CT.schema.state')} {switches.right.state ? "On" : "Off"}
                        </div>
                    </div>
                </div>
            </div>

            <div className="inverter-container">
                {[leftInverters, rightInverters].map((inverterGroup, index) => (
                    <div key={index} className="inverter-half">
                        {inverterGroup.map((inv) => (
                            <div key={inv.idInverter} onClick={() => handleInverterClick(inv)}>
                                <Inverter {...inv} toggleInverter={toggleInverter} />
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            {/* Modal para confirmar la acción de interruptores o inverters */}
            <Modal show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('scada.solarFarm.CT.schema.confirmAction')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSwitch ? (
                        <>{t('scada.solarFarm.CT.schema.want')} {switches[selectedSwitch]?.state ? t('scada.solarFarm.CT.schema.shutdown') : t('scada.solarFarm.CT.schema.on')} {t('scada.solarFarm.CT.schema.interruptor')} {switches[selectedSwitch]?.name}?</>
                    ) : isInverterInFault ? (
                        <>{t('scada.solarFarm.CT.schema.inverter')} {selectedInverter?.name} {t('scada.solarFarm.CT.schema.message')}</>
                    ) : (
                        <>{t('scada.solarFarm.CT.schema.want')} {selectedInverter?.statusLevel === '0' ? t('scada.solarFarm.CT.schema.on') : t('scada.solarFarm.CT.schema.shutdown')} {t('scada.solarFarm.CT.schema.inverter2')} {selectedInverter?.name}?</>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                    {t('scada.solarFarm.modalCommands.cancel')}
                    </Button>
                    {!isInverterInFault && (
                        <Button variant="primary" onClick={selectedSwitch ? handleModalConfirmSwitch : handleModalConfirmInverter}>
                            {t('scada.solarFarm.CT.schema.confirm')}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PCS;
